import Stars from "./raty";
new Stars();